import { Avatar, AvatarGroup, Box, IconButton, Typography, Chip } from '@mui/material';
import Images from '../../../../Assets/assetHelper';
import { useStyles } from '../styles';
import { useNavigate } from 'react-router-dom';

const CreatedGroupCard: React.FC<any> = (group) => {
  const classes = useStyles();
  const navigate = useNavigate();
  console.log(group, "group")

  const groupName: any = group?.groupName ? group?.groupName : "Title";
  const memberCount: any = group?.memberCount ? group?.memberCount : "-";
  const coverImage: any = group?.coverImage ? group?.coverImage : Images.Images.entreprenursOfKen42;
  const groupId: any = group?.id ? group?.id : "Title";
  const groupType: any = group?.type ? group?.type : "Public";
  const groupStatus: any = group?.status ? group?.status : "Approved";
  const fromProfile: any = group?.fromProfile ? group?.fromProfile : false;

  // Function to get chip background color based on group type (always #BFECFF for type)
  const getTypeChipBackgroundColor = () => {
    return '#BFECFF';
  };

  // Function to get chip background color based on status
  const getStatusChipBackgroundColor = (status: string) => {
    switch (status) {
      case 'Approved':
        return '#4CAF50'; // Success green
      case 'In Review':
        return '#FEEBBE';
      case 'Rejected':
        return '#F1BFBF';
      default:
        return '#4CAF50'; // Default to success green
    }
  };

  const handleJoinClick = () => {
    if (fromProfile) {
      navigate(`/groups/created-groups/${groupName}?id=${groupId}`, { state: { fromProfile: true } });
    } else {
      navigate(`/groups/created-groups/${groupName}?id=${groupId}`);
    }
  };

  return (
    <Box className={classes.GroupCard} style={{ cursor: 'pointer' }} onClick={handleJoinClick}>
      <Box sx={{ position: 'relative' }}>
        <img
          src={coverImage}
          alt="Discover Group"
          style={{ borderRadius: '10px 10px 0px 0px', height: 140, width: "100%" }}
        />
        {/* Status Chip - Top Left */}
        <Chip
          label={groupStatus}
          size="small"
          sx={{
            position: 'absolute',
            top: 8,
            left: 8,
            backgroundColor: getStatusChipBackgroundColor(groupStatus),
            color: '#fff',
            fontSize: '10px',
            height: '20px',
            fontWeight: '500',
            '& .MuiChip-label': {
              paddingLeft: '8px',
              paddingRight: '8px',
            }
          }}
        />
        {/* Type Chip - Top Right */}
        <Chip
          label={groupType}
          size="small"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            backgroundColor: getTypeChipBackgroundColor(),
            color: '#333',
            fontSize: '10px',
            height: '20px',
            fontWeight: '500',
            '& .MuiChip-label': {
              paddingLeft: '8px',
              paddingRight: '8px',
            }
          }}
        />
      </Box>
      <Box component={'div'} sx={{ padding: '10px 0px 0px 20px' }}>
        <Typography className={classes.classSixteen}>{groupName}</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', paddingTop: '2px' }}>
          <AvatarGroup max={4} className={classes.cardAvatarGroup}>
            {group?.members && group.members.length > 0 ? (
              group.members.slice(0, 4).map((member: any, index: number) => (
                <Avatar
                  key={index}
                  alt={member.name}
                  src={member.imageUrl || Images.Images.DefaultProfileImage}
                  sx={{ width: '18px', height: '18px', fontSize: '12px' }}
                />
              ))
            ) : (
              <Avatar
                alt="User"
                src={Images.Images.DefaultProfileImage}
                sx={{ width: '18px', height: '18px', fontSize: '12px' }}
              />
            )}
          </AvatarGroup>
          <Typography sx={{ fontSize: '9px', fontWeight: '400' }}>
            {memberCount > 0 ? `+${memberCount} members` : 'No members yet'}
          </Typography>
        </Box>
        <div className={classes.cardActionContainer}>
          <Typography sx={{ fontSize: '10.5px', fontWeight: '500' }}>View details</Typography>
          <IconButton sx={{ marginRight: '10px' }}>
            <img src={Images.Icons.ArrowForward} alt="ArrowForward" height={'12px'} width={'12px'} />
          </IconButton>
        </div>
      </Box>
    </Box>
  );
};

export default CreatedGroupCard;